import { 
  Object3D,
  PlaneGeometry,
  MeshBasicMaterial,
  Mesh,
  DoubleSide,
} from "three"

import preloader from '@/components/panorama/loaders/preloader';

export default class Keypoint extends Object3D {
  constructor (opts = {}) {
    super()
    const kgeometry = new PlaneGeometry( 60, 60 );
    const material = new MeshBasicMaterial( {
      transparent: true,
      side: DoubleSide,
      map: preloader.getTexture('kpMap'),
      alphaMap: preloader.getTexture('kpAlphaMap'),
      opacity: 1,
      depthWrite: false,
      depthTest: false,
    });
    this.fillMaterial = new MeshBasicMaterial( {
      transparent: true,
      side: DoubleSide,
      alphaMap: preloader.getTexture('kpAlphaMap'),
      opacity: 0,
      depthWrite: false,
      depthTest: false,
    });

    const plane = new Mesh( kgeometry, material );
    const plane2 = new Mesh( kgeometry, this.fillMaterial );
    this.uid = opts.uid

    if (opts.position) {
      this.position.set(opts.position.x, opts.position.y, opts.position.z)
    }

    if (opts.rotation) {
      this.rotation.set(opts.rotation.x, opts.rotation.y, opts.rotation.z)
    }

    plane.position.z -= 0.04;
    this.add(plane2);
    this.add(plane);

    this.hasBeenVisited = false;

    // const circleRadius = 40;
    // const circleShape = new Shape()
    //   .moveTo( 0, circleRadius )
    //   .quadraticCurveTo( circleRadius, circleRadius, circleRadius, 0 )
    //   .quadraticCurveTo( circleRadius, - circleRadius, 0, - circleRadius )
    //   .quadraticCurveTo( - circleRadius, - circleRadius, - circleRadius, 0 )
    //   .quadraticCurveTo( - circleRadius, circleRadius, 0, circleRadius );

    //   const points = circleShape.getPoints();
    //   const geometryPoints = new BufferGeometry().setFromPoints( points );

    //   let line = new Line( geometryPoints, new LineBasicMaterial( { color: 0xFFFFFF, lineWidth: 40 } ) );
      // line.position.set( x, y, z - 25 );
      // line.rotation.set( rx, ry, rz );
      // const s = 2;
      // line.scale.set( s, s, s );
      // this.add( line );

    // this.add = opt.category
  }

  hover(trigger = false) {
    if (trigger) {
      this.fillMaterial.opacity = 0.4
      document.body.style.cursor = 'pointer'
    } else {
      this.fillMaterial.opacity = this.hasBeenVisited ? 0.4 : 0
      document.body.style.cursor = 'auto'
    }
  }

  reset() {
    this.hasBeenVisited = false
    this.fillMaterial.opacity = 0
  }

  visited() {
    this.hasBeenVisited = true
    this.fillMaterial.opacity = 0.4
    // console.log('visited')
    // this.fillMaterial.color = new Color(0x06295c)
  }
}